export type PatientCaseFormMode = 'create' | 'manual-create' | 'edit-linked' | 'edit-unlinked';

// An edit that clears a linked case's reference would appear to save while the
// stored reference silently stays, so a linked case keeps requiring one.
const REFERENCE_REQUIRED: Record<PatientCaseFormMode, boolean> = {
  create: true,
  'manual-create': false,
  'edit-linked': true,
  'edit-unlinked': false,
};

export const getPatientCaseFormMode = (
  existingCase: { platoReferenceId: string | null } | null | undefined,
  isManualReferral: boolean,
): PatientCaseFormMode => {
  if (existingCase) return existingCase.platoReferenceId?.trim() ? 'edit-linked' : 'edit-unlinked';
  return isManualReferral ? 'manual-create' : 'create';
};

export const canSavePatientCase = (
  values: { patientDisplayName: string | null; platoReferenceId: string | null },
  mode: PatientCaseFormMode,
): boolean => Boolean(
  values.patientDisplayName?.trim() &&
  (!REFERENCE_REQUIRED[mode] || values.platoReferenceId?.trim()),
);
